import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ListProductVpsUsComponent from "../../../components/Customer/products/ListProductVpsUsComponent";

const CreateProductPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <ListProductVpsUsComponent groupProductId={ params.groupProductId } shouldRedirect={ () => redirect() } />;
}

export default CreateProductPage;